<template>
  <t-stepper v-model="step" class="new-user-stepper" :steps="steps">
    <v-stepper-window>
      <v-stepper-window-item :value="1">
        <form-user-basic-data @submit="step++" @cancel="emit('cancel')" />
      </v-stepper-window-item>

      <v-stepper-window-item :value="2">
        <form-user-address @submit="submit" />
      </v-stepper-window-item>
    </v-stepper-window>
  </t-stepper>
</template>

<script setup lang="ts">
import { ref, type Ref } from "vue";
import FormUserAddress from "./FormAddress.vue";
import FormUserBasicData from "./FormUserBasicData.vue";
import TStepper from "@/components/core/TStepper.vue";
import { Step } from "@/types/Step";

const emit = defineEmits<{
  cancel: [];
  submit: [];
}>();

defineOptions({
  name: "FormNewUser",
});

const step: Ref<number> = ref(1);

const steps: Step[] = [
  {
    step: 1,
    label: "Dados Pessoais",
    editable: true,
  },
  {
    step: 2,
    label: "Dados de Endereço",
  },
];

function submit(): void {
  emit("submit");
}

function reset(): void {
  step.value = 1;
}

defineExpose({
  reset,
});
</script>

<style lang="scss">
.new-user-stepper .v-stepper-window-item {
  padding: 0;
}
</style>
